import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Rocket, FileText, Lock, ClipboardList, HelpCircle, Shield, Home } from 'lucide-react';
import './Help.css';

const Help = () => {
  const navigate = useNavigate();

  const helpTopics = [
    {
      title: 'Getting Started',
      icon: Rocket,
      description: 'Learn the basics of using SafeHer',
      topics: [
        'Creating your account',
        'Navigating the map',
        'Understanding report types',
        'Profile settings'
      ]
    },
    {
      title: 'Submitting Reports',
      icon: FileText,
      description: 'How to share safety information',
      topics: [
        'How to submit a report',
        'Choosing report levels',
        'Anonymous reporting',
        'Editing your reports'
      ]
    },
    {
      title: 'Safety & Privacy',
      icon: Lock,
      description: 'Keeping your information secure',
      topics: [
        'Your privacy settings',
        'Data protection',
        'Anonymous vs public',
        'Account security'
      ]
    },
    {
      title: 'Community Guidelines',
      icon: ClipboardList,
      description: 'Rules and best practices',
      topics: [
        'Community standards',
        'Reporting abuse',
        'Moderator role',
        'User conduct'
      ]
    }
  ];

  return (
    <div className="help-page">
      <div className="help-header">
        <button className="back-button" onClick={() => navigate(-1)}>
          ← Back
        </button>
        <h1>Help Center</h1>
        <p>Find answers and get support</p>
      </div>

      <div className="help-content">
        <div className="quick-links">
          <h2>Quick Links</h2>
          <div className="quick-links-grid">
            <button onClick={() => navigate('/faq')} className="quick-link-btn">
              <span className="link-icon" aria-hidden="true"><HelpCircle size={16} /></span>
              <span>FAQ</span>
            </button>
            <button onClick={() => navigate('/about/moderators')} className="quick-link-btn">
              <span className="link-icon" aria-hidden="true"><Shield size={16} /></span>
              <span>Moderators</span>
            </button>
            <button onClick={() => navigate('/')} className="quick-link-btn">
              <span className="link-icon" aria-hidden="true"><Home size={16} /></span>
              <span>Home</span>
            </button>
          </div>
        </div>

        <div className="help-topics">
          <h2>Browse Help Topics</h2>
          <div className="topics-grid">
            {helpTopics.map((topic, index) => (
              <div key={index} className="topic-card">
                <div className="topic-icon" aria-hidden="true">{React.createElement(topic.icon, { size: 22 })}</div>
                <h3>{topic.title}</h3>
                <p>{topic.description}</p>
                <ul className="topic-list">
                  {topic.topics.map((item, idx) => (
                    <li key={idx}>{item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="contact-section">
          <h2>Still Need Help?</h2>
          <p>Can't find what you're looking for? Check our FAQ or contact support.</p>
          <div className="contact-buttons">
            <button onClick={() => navigate('/faq')} className="contact-btn">
              View FAQ
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Help;
